import {Injectable} from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreCollection,
  CollectionReference,
  DocumentData,
  Query
} from "@angular/fire/compat/firestore";
import {AngularFireAuth} from "@angular/fire/compat/auth";
import {BaseUserService, isSupportUser} from "../base-user/base-user.service";
import {first} from "rxjs/operators";
import {environment} from "../../../../environments/environment";
import {lastValueFrom} from "rxjs";
import {FirestoreCollectionEnum} from "../../enums/firestore-collection.enum";
import {FirestoreWhereClauseModel} from "../../models/firestore-where-clause.model";
import {FirebaseTimestampModel} from "../../../construction-chat/models/firebase-timestamp.model";

@Injectable({
  providedIn: 'root'
})
export abstract class FirestoreService {

  constructor(
    protected readonly afs: AngularFirestore,
    protected readonly angularFireAuth: AngularFireAuth,
    protected readonly baseUserService: BaseUserService
  ) {
  }

  async signInWithEmailAndPassword(email: string, chatToken: string): Promise<void> {
    const loggedUser = await this.baseUserService.loggedUser();
    if(isSupportUser(loggedUser.rolesJson)) {
      console.log(`Not logging support user into firebase`);
      return;
    }

    const emailToUse = this.emailToUse(email);

    if (!await this.isUserLoggedIn()) {
      await this.angularFireAuth.signInWithEmailAndPassword(emailToUse, chatToken);
    }
  }

  emailToUse(email: string): string {
    const env = environment.env;
    if(env == 'prod') return email;
    // if(env == 'prod' || env == 'local') return email;

    const devHash = environment.devHash || '';
    // if(environment == 'prod' || environment == 'local') return email;
    console.log(devHash);
    const emailToUse = `${devHash}${env}${email}`;
    console.log(`Utilizzo email diversa per ambiente non prod: ${emailToUse} per ${email}`);
    return emailToUse;

    // const separator = '@';
    // let emailToUse;
    // if (email.includes(separator)) { // es: prima@dopo
    //   const split = email.split('@');
    //   emailToUse = `${split[0]}${separator}${env}domain.com`;
    // } else { // es: prima
    //   emailToUse = `${email}${separator}${env}domain.com`
    // }
    // console.log(`Utilizzo email diversa per ambiente non prod: ${emailToUse} per ${email}`);
    // return emailToUse; // prima@envdomain.com
  }

  async logout() {
    if (await this.isUserLoggedIn()) {
      await this.angularFireAuth.signOut();
    }
  }

  queryFirebase(ref: CollectionReference<DocumentData> | Query<any>, limit?: number, startAfter?: any,
                whereClauses?: FirestoreWhereClauseModel[], defaultSort = true, customSort?: string[]) {
    let query;

    // console.log(whereClauses)

    if (whereClauses?.length > 0) {
      let i = 0;
      query = ref.where(whereClauses[i].field, whereClauses[i].operator, whereClauses[i].value);
      for (let i = 1; i < whereClauses.length; i++) {
        query = query.where(whereClauses[i].field, whereClauses[i].operator, whereClauses[i].value);
      }
    } else {
      query = ref;
    }

    if (defaultSort) {
      query = query.orderBy('createdAt', 'desc');
    }

    if(customSort) {
      query = query.orderBy(customSort[0], customSort[1]);
    }

    if (startAfter) {
      query = query.startAfter(startAfter);
    }

    if (limit) {
      query = query.limit(limit);
    }
    return query;
  }

  createFirebaseDateTime(): FirebaseTimestampModel {
    const seconds = Math.round(new Date().getTime() / 1000);
    const nanosec = new Date().getTime() * 1000 * 1000;
    return { seconds: seconds, nanoseconds: nanosec }
  }

  getCollectionRef(collection: FirestoreCollectionEnum): AngularFirestoreCollection {
    return this.afs.collection(collection);
  }

  async isUserLoggedIn(): Promise<boolean> {
    const $user = this.angularFireAuth.user.pipe(first());
    const user = await lastValueFrom($user);

    return !!user?.uid;
  }
}
